// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"369":"b31ebecf","931":"86fd3234"}[chunkId] + ".css";
};